module.exports = __webpack_public_path__ + "static/headphones-popular-products-section-9daf405d183437bec4c1af88293bcc58.png";